import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../CoroutineDispatcher.mjs';
import { Delay9umexudtwyie as Delay } from '../Delay.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_DefaultDelay3q9fawcutqbnw as get_DefaultDelay } from '../CoroutineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedDispatcherClass;
function NamedDispatcher() {
  if (NamedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(dispatcher, name) {
        super();
        var tmp = this;
        var tmp0_elvis_lhs = isInterface(dispatcher, Delay()) ? dispatcher : null;
        tmp.a1k_1 = tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
        this.b1k_1 = dispatcher;
        this.c1k_1 = name;
      }
      y12(context) {
        return this.b1k_1.y12(context);
      }
      b13(context, block) {
        return this.b1k_1.b13(context, block);
      }
      toString() {
        return this.c1k_1;
      }
      p13(timeMillis, continuation) {
        this.a1k_1.p13(timeMillis, continuation);
      }
      q13(timeMillis, block, context) {
        return this.a1k_1.q13(timeMillis, block, context);
      }
    }
    initMetadataForClass($, 'NamedDispatcher', VOID, VOID, [CoroutineDispatcher(), Delay()], [1]);
    NamedDispatcherClass = $;
  }
  return NamedDispatcherClass;
}
//region block: exports
export {
  NamedDispatcher as NamedDispatcher2rg47sbefduxc,
};
//endregion

//# sourceMappingURL=NamedDispatcher.mjs.map
